// Constants
import { ENQUEUE_SNACKBAR, CLOSE_SNACKBAR, REMOVE_SNACKBAR } from './constants';

const initialState = [];

export default function(state = initialState, action) {
    switch (action.type) {
        case ENQUEUE_SNACKBAR:
            return [
                ...state,
                {
                    key: action.payload.key,
                    ...action.payload.notification
                }
            ];
        case CLOSE_SNACKBAR:
            return state.map(notification =>
                action.payload.dismissAll ||
                notification.key === action.payload.key
                    ? { ...notification, dismissed: true }
                    : { ...notification }
            );
        case REMOVE_SNACKBAR:
            return state.filter(
                notification => notification.key !== action.payload.key
            );
        default:
            return state;
    }
}
